import React from "react";

import List from "./list";
import Form from "./form";
import Show from "./show";
import AssignTask from "./assignTask";

import { Switch, Route } from "react-router-dom";

import {
    LAYOUT_FINANCE_PURCHASE_ORDER_LIST,
    LAYOUT_FINANCE_PURCHASE_ORDER_FORM,
    LAYOUT_FINANCE_PURCHASE_ORDER_SHOW,
    LAYOUT_FINANCE_PURCHASE_ORDER_ASSIGN_TASK,
} from "../navigation";

const Router = (props) => (
    <Switch>
        <Route path={LAYOUT_FINANCE_PURCHASE_ORDER_LIST} render={(routeProps) => <List {...props} {...routeProps} />} />
        <Route path={LAYOUT_FINANCE_PURCHASE_ORDER_FORM} render={(routeProps) => <Form {...props} {...routeProps} />} />
        <Route
            path={LAYOUT_FINANCE_PURCHASE_ORDER_SHOW(":id")}
            render={(routeProps) => <Show {...props} {...routeProps} />}
        />
        <Route
            path={LAYOUT_FINANCE_PURCHASE_ORDER_ASSIGN_TASK(":id", ":code", ":vendorId")}
            render={(routeProps) => <AssignTask {...props} {...routeProps} />}
        />
    </Switch>
);

export default Router;
